var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#222222;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1068,126H132c-39.7,0-72,32.3-72,72v552c0,39.7,32.3,72,72,72h457.1c12.2,141,130.8,252,274.9,252 c152.2,0,276-123.8,276-276V198C1140,158.3,1107.7,126,1068,126z M864,1026c-125.8,0-228-102.2-228-228s102.2-228,228-228 s228,102.2,228,228S989.8,1026,864,1026z M1092,642.7C1042.2,569.9,958.7,522,864,522c-144.1,0-262.7,111-274.9,252H132 c-13.2,0-24-10.8-24-24V414h984V642.7z M1092,366H108v-72h984V366z M1092,246H108v-48c0-13.2,10.8-24,24-24h936 c13.2,0,24,10.8,24,24V246z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204,702h120c13.2,0,24-10.8,24-24s-10.8-24-24-24H204c-13.2,0-24,10.8-24,24S190.8,702,204,702z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M444,702h48c13.2,0,24-10.8,24-24s-10.8-24-24-24h-48c-13.2,0-24,10.8-24,24S430.8,702,444,702z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M919.1,709.1l-144,144c-9.5,9.4-9.5,24.5,0,33.8c4.7,4.7,10.8,7.1,16.9,7.1s12.2-2.4,16.9-7.1l144-144 c9.5-9.4,9.5-24.5,0-33.8C943.6,699.6,928.4,699.6,919.1,709.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M816,726c0,13.3-10.7,24-24,24s-24-10.7-24-24s10.7-24,24-24S816,712.7,816,726"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M960,870c0,13.3-10.7,24-24,24s-24-10.7-24-24s10.7-24,24-24S960,856.7,960,870"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCard);
export default __webpack_public_path__ + "static/media/payment-card.a54818888d4205a1c70615144f91e285.svg";
export { ForwardRef as ReactComponent };